import type { ContextId } from '../../store/slices/helpSlice';

export interface ContextHelpHintDefinition {
  id: string;
  contextId: ContextId;
  title: string;
  content: string;
  topicId?: string;
}

export const HELP_CONTEXT_HINTS: ContextHelpHintDefinition[] = [
  {
    id: 'screening_run',
    contextId: 'screening',
    title: 'Run Screening',
    content:
      'Start with a narrow filter set, run screening, then iterate. This gives clearer signal quality than broad first scans.',
    topicId: 'screening_filters',
  },
  {
    id: 'charts_validate',
    contextId: 'charts',
    title: 'Validate Quickly',
    content:
      'Overlay SMA-150 (and SMA-200 if it is your line). Keep setups where price sits on or above the line with slope flat or rising. Reject the rest fast.',
    topicId: 'charts_workflow',
  },
  {
    id: 'chart_focus_deep',
    contextId: 'chart_view',
    title: 'From Chart to Analysis',
    content:
      'When a setup looks strong, jump to Deep Analysis to review patterns, indicator alignment, and risk context.',
    topicId: 'deep_analysis_overview',
  },
  {
    id: 'selected_chart_rule',
    contextId: 'chart_view',
    title: 'Respect the Line',
    content:
      'Watch the SMA-150 on this chart. A daily close below it is your exit - no second-guessing. Ratchet the stop up ~10% with every leg higher.',
    topicId: 'ma_150_strategy',
  },
  {
    id: 'deep_analysis_reading',
    contextId: 'deep_analysis',
    title: 'Interpretation Order',
    content:
      'Read the MA Pattern card first - it only appears when a real pattern triggered. Then confirm price is still above SMA-150 before acting. AI text is context, not advice.',
    topicId: 'deep_analysis_overview',
  },
  {
    id: 'favorites_focus',
    contextId: 'favorites',
    title: 'Keep a Focused List',
    content:
      'Use Favorites as a high-conviction watchlist. Too many names reduce signal quality and execution speed.',
    topicId: 'favorites_and_alerts',
  },
];

export function getContextHints(contextId: ContextId): ContextHelpHintDefinition[] {
  return HELP_CONTEXT_HINTS.filter((hint) => hint.contextId === contextId);
}
